var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ContainerClinicalPatientInfo"}},[_c('Patient',{attrs:{"editMode":this.$attrs.editMode,"HaveChanges":_vm.HaveChanges}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }